import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';

    export default GenericModel.extend({
        idAttribute: 'creditId',
        defaults: {
            creditId: 0,
            credits: null,
            amount: null,
            date: null,
            paymentMethod: null,
            invoice: null,
            paymentId: null,
            invoiceDetails: null,
            cardLastDigits: null
        }
    });
